import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slide']
  static values= {
    speed: { type: Number, default: 5000 }
  }

  connect() {
    this.current = 0
    this.interval = null

    this.#start()

    this.element.addEventListener('mouseenter', () => this.#stop())
    this.element.addEventListener('mouseleave', () => this.#start())
    this.element.addEventListener('touchstart', () => this.#stop())
    this.element.addEventListener('touchend', () => this.#start())
  }

  disconnect() {
    this.#stop()
  }

  get slides() {
    return this.slideTargets
  }

  #showNext() {
    this.slides[this.current].classList.remove('is-active')
    this.current = (this.current + 1) % this.slides.length
    this.slides[this.current].classList.add('is-active')
  }

  #start() {
    if (this.interval) return
    this.interval = setInterval(() => this.#showNext(), this.speedValue)
  }

  #stop() {
    clearInterval(this.interval)
    this.interval = null
  }
}
